import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const propTypes = {};

const AnimatedContainer = ({ isFade, ...props }) => {
  //! State
  const animationStyle = useMemo(() => {
    if (isFade) {
      return {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      };
    }

    return {
      initial: { opacity: 0, y: 30 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: 20 },
    };
  }, [isFade]);

  //! Function

  //! Render
  return (
    <motion.div
      id={props.id}
      className={props.className}
      style={props.style}
      layout
      {...animationStyle}
      {...props}
    >
      {props.children}
    </motion.div>
  );
};

AnimatedContainer.propTypes = propTypes;
export default AnimatedContainer;
